import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowTriangleRight"><Path d="M7.6126 4.26664C5.95307 3.43716 4 4.64337 4 6.49881V17.5024C4 19.3579 5.95307 20.5641 7.61261 19.7346L18.62 14.2328C20.46 13.3131 20.46 10.6881 18.62 9.76846L7.6126 4.26664Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
